function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Input, Skeleton, List, Drawer, Button } from "antd";
import { Search as SearchIc } from "react-bootstrap-icons";
import { Folder2Open } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import MailView from "../components/MailView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = function Search() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    mails = _useState2[0],
    setMails = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentMail = _useState8[0],
    setCurrentMail = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isMailDetailsVisible = _useState0[0],
    setIsMailDetailsVisible = _useState0[1];
  var onOpenClick = function onOpenClick(m) {
    setCurrentMail(m);
    setIsMailDetailsVisible(true);
  };
  var onInputChange = function onInputChange(e) {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getmailsfromkeyword/" + e.target.value + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setMails(response.data.mails);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 9,
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(SearchIc, {}),
              onChange: onInputChange,
              placeholder: "Que cherchez-vous ?",
              size: "large"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            className: "cool-radius white-bg",
            style: {
              minHeight: "550px"
            },
            children: [/*#__PURE__*/_jsx(List, {
              loading: isDataLoading,
              itemLayout: "horizontal",
              dataSource: mails,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsxs(List.Item, {
                  actions: [/*#__PURE__*/_jsx(Button, {
                    type: "link",
                    onClick: function onClick() {
                      return onOpenClick(item);
                    },
                    children: /*#__PURE__*/_jsx(Folder2Open, {
                      size: 20
                    })
                  })],
                  children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                    title: item.subject,
                    description: /*#__PURE__*/_jsx(Moment, {
                      format: "DD/MM/YYYY",
                      children: item.created_at
                    })
                  }), /*#__PURE__*/_jsx("span", {
                    children: item.sender
                  })]
                });
              }
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })]
        })
      })
    }), currentMail && /*#__PURE__*/_jsx(Drawer, {
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: currentMail.subject
      }),
      width: "90%",
      visible: isMailDetailsVisible,
      onClose: function onClose() {
        setIsMailDetailsVisible(false);
      },
      children: /*#__PURE__*/_jsx(MailView, {
        m: currentMail
      })
    })]
  });
};
export default Search;